<template>
  <el-dialog :visible="dialogShow" title="发布公告" @open="open" @close="close" width="850px" :close-on-click-modal="false"
    center>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" label-position="left">
      <el-form-item label="公告类型" class="title">
        <el-radio v-model="newsType" label="普通">普通</el-radio>
        <el-radio v-model="newsType" label="重要">重要</el-radio>
        <el-radio v-model="newsType" label="紧急">紧急</el-radio>
      </el-form-item>
      <el-form-item label="接收者" class="title">
        <el-radio v-model="newsGroupType" label="0" @change="newsGroupSelect">全部师生</el-radio>
        <el-radio v-model="newsGroupType" label="1" @change="newsGroupSelect">所有家长</el-radio>
        <el-radio v-model="newsGroupType" label="2" @change="newsGroupSelect">所有老师</el-radio>
      </el-form-item>
      <el-form-item label="年级" prop="title" class="title" :rules="[{ validator: validateClassName }]">
        <el-select v-model="gradeName" placeholder="请选择" @change="gradeChange" clearable>
          <el-option v-for="(item, index) in gradeSelect" :key="index" :label="item.gradeName" :value="item.gradeId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班级" prop="title" class="title" :rules="[{ validator: validateClassName }]">
        <el-select v-model="className" placeholder="请选择" @change="changeHandle" clearable>
          <el-option v-for="(item, index) in classSelect" :key="index" :label="item.className" :value="item.classId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分组" prop="title" class="title" :rules="[{ validator: validateClassName }]"
        v-show="crowdSelectShow">
        <el-select v-model="crowdSelectText" placeholder="选择分组" clearable>
          <el-option :label="item.label" :value="item.value" v-for="(item, index) in crowdSelectList"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" label-position="top"
      :inline="true">
      <el-form-item label="公告标题" prop="title" class="title">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
        <!-- <el-date-picker style="width: 235px" v-model="ruleForm.schoolYear" type="year" placeholder="选择学年"
          @change="schoolYearChangeHandle">
        </el-date-picker> -->
        <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYear" />
      </el-form-item>
      <el-form-item label="选择学期:" label-width="100px" prop="semester">
        <el-select v-model="ruleForm.semester" placeholder="请选择学期" style="width: 235px">
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布方式:" label-width="100px" prop="publicType">
        <el-select v-model="ruleForm.publicType" placeholder="请选择发布方式" style="width: 250px">
          <el-option v-for="item in noticeMethodList" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="ruleForm.publicType == '2'" label="发布时间:" label-width="100px" prop="publicTime">
        <el-date-picker v-model="ruleForm.publicTime" value-format="yyyy-MM-dd HH:mm" type="datetime"
          placeholder="选择日期时间" style="width: 235px">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" label-position="top">
      <el-form-item label="公告内容" prop="content">
        <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 10 }" v-model="ruleForm.content"
          :maxlength="maxlength" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div class="notice-upload">
      <el-upload class="upload" :auto-upload="false" :action="action" list-type="picture-card" accept=".jpg,.png,.jpeg"
        multiple :http-request="uploadFile" ref="upload" :limit="3" :on-change="onChange" :on-remove="onRemove"
        :on-preview="handlePictureCardPreview" :on-exceed="onExceed">
        <div class="iconfont icon-camera add"></div>
      </el-upload>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm"> 发布 </el-button>
      <el-button type="primary" @click="close" plain> 关闭 </el-button>
    </div>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import axios from "axios";

import { baseURL } from "@/api/request"; // 服务器地址
export default {
  name: "",
  props: {
    noticeAddShow: {
      type: Boolean,
      default: false,
    },
    gradeSelect: {
      type: Array,
    },
    crowdSelectList: {
      type: Array,
    },
    semesterOptions: {
      type: Array,
    },
    semester: {
      type: [String, Number],
    },
    schoolYear: {
      type: [String, Number],
    },
    noticeMethodList: {
      type: Array
    }
  },
  watch: {
    noticeAddShow() {
      this.dialogShow = this.noticeAddShow;
    },
  },
  data() {
    return {
      type: "1",
      dialogShow: false,
      ruleForm: {
        title: "",
        content: "",
        schoolYear: "",
        semester: "",
        publicType: "1",
        publicTime: ""
      },
      newsType: "普通",
      rules: {
        title: [{ required: true, message: "请输入公告标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入公告内容", trigger: "blur" }],
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
        publicType: [{ required: true, message: "请选择发布方式", trigger: "change" }],
        publicTime: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
      maxlength: 1000,
      formData: "", // 文件上传参数
      action: "", // 文件上传路径
      // 待提交的图片
      fileList: [],
      // 预览参数
      dialogImageUrl: "",
      dialogVisible: false,
      crowdSelectText: "",
      count: 1,
      // 班级年级数据
      classSelectList: [],
      // 处理后的班级年级多选数据
      // classSelect: [],
      // 级联选择器属性配置
      // classProps: {
      //   expandTrigger: "hover",
      //   children: "schoolClassList",
      // },
      // 选中后的班级年级
      className: [],
      // gradeName: [],
      newsGroupType: "0", // 接收者
      classSelect: [], // 班级选择列表
      gradeName: "", // 年级
      crowdSelectShow: false,
    };
  },
  created() {
    // console.log(baseURL)
    this.action = `${baseURL}${this.$url.newsAdd}`;
  },
  methods: {
    schoolYearChangeHandle(e) {
      // console.log(e);
      this.ruleForm.schoolYear = e ? "" + e.getFullYear() : "";
    },
    newsGroupSelect(e) {
      this.crowdSelectShow = e == 2 ? true : false;
    },
    // 班级/年级 不校验
    validateClassName(rule, value, callback) {
      // 检查条件，如果需要跳过校验，则直接调用 callback() 以跳过校验
      callback();
    },
    // 选择班级
    changeHandle(e) {
      // console.log("选中的班级==>", e, this.className);
      // console.log(this.className);
    },
    gradeChange(e) {
      // console.log(this.gradeName);
      if (!e) return (this.classSelect = []);
      this.classSelect = this.gradeSelect.find(
        (item) => item.gradeId === e
      ).schoolClassList;
    },
    open() {
      this.ruleForm = {
        title: "",
        content: "",
        schoolYear: this.schoolYear,
        semester: this.semester,
        publicType: "1",
        publicTime: ""
      };
    },
    close() {
      this.ruleForm = {
        title: "",
        content: "",
        publicType: "1",
        publicTime: ""
      };
      this.formData = "";
      this.fileList = [];
      this.type = "1";
      this.gradeName = "";
      this.className = [];
      this.crowdSelectText = "";
      this.newsType = "普通";
      this.newsGroupType = "0";
      // this.className = [];
      this.$refs.upload.clearFiles();
      this.$emit("update:noticeAddShow", false);
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
    // 上传预览图片时调用
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 文件超出个数限制时
    onExceed(file, fileList) {
      return this.$message("最多可上传三张");
    },
    // 添加文件、上传成功和上传失败时都会被调用
    onChange(file, fileList) {
      let limit = file.size / 1024 / 1024 < 2;
      let file_type = file.name.split(".")[1];
      if (!/^(jpg|png|jpeg)$/g.test(file_type)) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("请选择jpg,png,jpeg类型文件");
      } else if (!limit) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("上传图片大小不能超过 2MB!");
      } else {
        this.fileList = fileList;
      }
    },
    // 移除图片时被调用
    onRemove(file, fileList) {
      this.fileList = fileList;
    },
    // 覆盖默认的上传行为，可以自定义上传的实现
    // 向FormData对象设置文件
    uploadFile(file) {
      // console.log(file.file)
      // this.formData.append(`image${this.count}`, file.file);
      this.formData.append("file", file.file);
      this.count++;
    },
    // 提交
    submitForm() {
      // console.log(this.ruleForm.publicType, this.ruleForm.publicTime);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // new FormData()创建创建FormData对象
          this.formData = new FormData();

          // 有图片
          if (this.fileList.length) {
            this.$refs.upload.submit(); // => 会调用uploadFile(file)
          }

          // 向FormData对象设置其他参数
          let user = this.user;
          this.formData.append("schoolId", user.schoolId);
          this.formData.append("title", this.ruleForm.title);
          this.formData.append("content", this.ruleForm.content);
          this.formData.append("createBy", user.id);
          this.formData.append("crowdId", this.crowdSelectText);
          this.formData.append("newsGroup", this.newsGroupType);
          this.formData.append("newsType", this.newsType);
          this.formData.append("gradeId", this.gradeName);
          this.formData.append("classId", this.className);
          this.formData.append("schoolYear", this.ruleForm.schoolYear);
          this.formData.append("semester", this.ruleForm.semester);
          this.formData.append("publicType", this.ruleForm.publicType);
          if (this.ruleForm.publicType == '2') {
            this.formData.append("publicTime", this.ruleForm.publicTime);
          };

          let config = {
            headers: {
              bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
              "Content-Type": "multipart/form-data",
            },
          };
          // 调用接口
          axios
            .post(this.action, this.formData, config)
            .then((res) => {
              this.count = 1;
              // res.data 服务器返回的数据
              let data = res.data;
              // console.log(res);
              if (data.code == 200) {
                // 上传成功，刷新列表，关闭dialog
                this.$emit("refresh");
                this.close();
                this.$message.success(data.msg);
                return;
              } else if (data.code == 401 || data.code == 403) {
                // token失效
                this.$message.error("获取用户信息失败，请重新登录");
                this.$store.dispatch("user/resetToken");
                this.$router.replace({
                  path: "login",
                  query: { redirect: this.$router.currentRoute.fullPath },
                });
              } else if (data.code == 201) {
                this.$message.success(
                  "发布成功！但公告内容含有敏感字,已交给管理员审核。"
                );
                this.close();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
              this.count = 1;
              return this.$message.error("发布失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./notice-add.scss";
</style>
